import {NavLink} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_gori/helpers'

interface NavDropdownCardItemProps {
  path: string
  icon: string
  description: string
  label: React.ReactNode
  onClick?: () => void
  external?: boolean
  compact?: boolean
}

const NavDropdownCardItem: React.FC<NavDropdownCardItemProps> = ({
  path,
  icon,
  description,
  label,
  onClick,
  external = false,
  compact = false,
}) => {
  const content = compact ? (
    label
  ) : (
    <>
      <img src={toAbsoluteUrl(icon)} alt='' className='nav-dropdown-card__icon' />
      <div className='nav-dropdown-card__text'>
        <span className='nav-dropdown-card__description'>{description}</span>
        <span className='nav-dropdown-card__name'>{label}</span>
      </div>
    </>
  )

  const className = compact ? 'nav-link' : 'nav-link nav-dropdown-card'

  return (
    <li>
      {external ? (
        <a
          href={path}
          className={className}
          target='_blank'
          rel='noopener noreferrer'
          onClick={onClick}
        >
          {content}
        </a>
      ) : (
        <NavLink to={path} className={className} onClick={onClick}>
          {content}
        </NavLink>
      )}
    </li>
  )
}

export {NavDropdownCardItem}
